import filter from "./filters"

export default{
    install(Vue, options){
        Vue.mixin({
            data: () => ({
                sharedActions:{
                    ...filter,
                }
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/utils/sharedActions/index.js